import { Card, Row, Switch, Typography } from "antd";
import type { FC } from "react";

const { Text } = Typography;
interface IServiceCard {
  title: string;
  value?: boolean;
}
export const ServiceCard: FC<IServiceCard> = ({ title, value }) => {
  return (
    <Card>
      <Row justify="space-between">
        <Text>{title}</Text>
        <Switch checked={value} checkedChildren="ON" unCheckedChildren="OFF" />
      </Row>
    </Card>
  );
};
